export default "__VITE_ASSET__BxpfH5jY__"